import React, { useEffect, useState } from 'react';
import MapGL from '@urbica/react-map-gl';
import { motion } from 'framer-motion';
type Props = {
  viewport: {
    latitude: number;
    longitude: number;
    zoom: number;
  };
  style?: React.CSSProperties;
};

export const Map: React.FC<Props> = ({
  viewport,
  children,
  style = {
    height: '100vh',
    width: '100vw',
  },
}) => {
  const [viewPort, setViewPort] = useState(viewport);

  useEffect(() => {
    if (viewport) setViewPort(viewport);
  }, [viewport]);

  useEffect(() => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = "https://api.tiles.mapbox.com/mapbox-gl-js/v1.12.0/mapbox-gl.css"
    document.body.appendChild(link);
  },[]);

  return (
    <motion.div animate={{ opacity: 1 }} initial={{ opacity: 0 }}>
      <MapGL
        accessToken="pk.eyJ1IjoiYm9vbmFnZW5jeWlybCIsImEiOiJjamE3emdlZ3YwMXIxMnhxbWRqNGRxY3huIn0.RnmocFzP2hqvfi9nnTgi0A"
        style={style}
        {...viewPort}
        onViewportChange={v => setViewPort(v)}
        mapStyle="mapbox://styles/mapbox/dark-v10">
        {children}
      </MapGL>
    </motion.div>
  );
};
